import { Button, Heading, HStack, Text } from "@chakra-ui/react";
import React from "react";
import useWallet from "../Settings/Billing/useWallet";
import { useNavigate } from "react-router-dom";

export default function SidebarWallet() {
  const { wallet } = useWallet();
  const navigate = useNavigate();
  const currency = "USD";
  const balance = wallet?.wallet_balance || 0;
  const handleClick = () => {
    navigate("/settings/billing");
  };

  return (
    <Button onClick={handleClick}>
      <HStack spacing={2} justifyContent={"space-between"} w={"100%"}>
        <Text fontSize={"md"} fontWeight={"bold"}>
          Wallet
        </Text>
        <Heading fontSize={14}>
          <Text as={"span"}>{currency}</Text>{" "}
          <Text as={"span"} color={balance > 0 ? "green" : "red"}>
            {balance.toFixed(2)}
          </Text>
        </Heading>
      </HStack>
    </Button>
  );
}
